import { ref } from 'vue'
import { defineStore } from 'pinia'

const useDrawStore = defineStore('draw', () => {
  const features = ref([])
  const selectedFeatures = ref([])
  const isDrawLineActive = ref(false)
  const isDrawPolygonActive = ref(false)
  const onDelete = ref(false)
  const drawMode = ref(null)
  const popups = ref({})

  return {
    features,
    selectedFeatures,
    isDrawLineActive,
    isDrawPolygonActive,
    onDelete,
    drawMode,
    popups,
  }
})

export default useDrawStore
